import { render, staticRenderFns } from "./CCustomSelectHeader.vue?vue&type=template&id=d854f542&scoped=true&"
import script from "./CCustomSelectHeader.vue?vue&type=script&lang=ts&"
export * from "./CCustomSelectHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CCustomSelectHeader.vue?vue&type=style&index=0&id=d854f542&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d854f542",
  null
  
)

export default component.exports